export default {
  copyright: "2020 All Rights Reserved.",
  yes: "Yes",
  no: "No",
  goTo: "Go To",
  goToWebsite: "Go to website"
};
